import React from "react";
import styles from "./Icon.module.css";

const RightFitSearchTimeline = ({ width = 84, height = 84, circleClassName = "" }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 84.84 84.84"
            width={width}
            height={height}
        >
            <g>
                <g>
                    <circle className={circleClassName} cx="42.42" cy="42.42" r="42.42" />

                    <path
                        className={styles.white}
                        d="M68.59,64.78H17.34V22.13H68.59Zm-48.25-3H65.59V25.13H20.34Z"
                    />
                    <rect
                        className={styles.white}
                        x="36.57"
                        y="20.39"
                        width="3"
                        height="6.75"
                    />
                    <rect
                        className={styles.white}
                        x="46.36"
                        y="20.39"
                        width="3"
                        height="6.75"
                    />
                    <rect
                        className={styles.white}
                        x="56.16"
                        y="20.39"
                        width="3"
                        height="6.75"
                    />
                    <rect
                        className={styles.white}
                        x="26"
                        y="36.17"
                        width="3"
                        height="1.7"
                    />
                    <rect
                        className={styles.white}
                        x="33.74"
                        y="36.17"
                        width="3"
                        height="1.7"
                    />
                    <rect
                        className={styles.white}
                        x="41.49"
                        y="36.17"
                        width="3"
                        height="1.7"
                    />
                    <rect
                        className={styles.white}
                        x="49.23"
                        y="36.17"
                        width="3"
                        height="1.7"
                    />
                    <rect
                        className={styles.white}
                        x="56.93"
                        y="36.15"
                        width="3"
                        height="1.7"
                    />
                    <path
                        className={styles.white}
                        d="M52.32,50.22H49A2.91,2.91,0,0,1,46,47.31V44A2.91,2.91,0,0,1,49,41h3.37A2.91,2.91,0,0,1,55.23,44v3.36A2.93,2.93,0,0,1,52.32,50.22Zm-3.28-3h3.18V44.05H49Z"
                    />
                    <rect
                        className={styles.white}
                        x="56.93"
                        y="44.73"
                        width="3"
                        height="1.73"
                    />
                    <rect
                        className={styles.white}
                        x="41.44"
                        y="44.73"
                        width="3"
                        height="1.73"
                    />
                    <rect
                        className={styles.white}
                        x="33.7"
                        y="44.73"
                        width="3"
                        height="1.73"
                    />
                    <rect
                        className={styles.white}
                        x="26"
                        y="44.73"
                        width="3"
                        height="1.7"
                    />

                    <rect
                        className={styles.white}
                        x="26"
                        y="53.29"
                        width="3"
                        height="1.7"
                    />
                    <rect
                        className={styles.white}
                        x="33.74"
                        y="53.29"
                        width="3"
                        height="1.7"
                    />
                    <rect
                        className={styles.white}
                        x="41.49"
                        y="53.29"
                        width="3"
                        height="1.7"
                    />
                </g>
            </g>
        </svg>
    );
};

export default RightFitSearchTimeline;
